import { createContext } from "react";

export interface ProfileFilterContextValue {
  selectedProfileIds: number[];
  setSelectedProfileIds: (ids: number[]) => void;
}

export const ProfileFilterContext = createContext<ProfileFilterContextValue>({
  selectedProfileIds: [],
  setSelectedProfileIds: () => {},
});
